import React, { useContext, useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { Helmet } from 'react-helmet-async';
import { getDetailsGql } from '../gql';
import EventDetails from '../components/EventDetails';
import SuccessSummary from '../components/SuccessSummary';
import { LayoutContext } from '../../../stores/LayoutStore';

function CheckoutSuccessPage() {
  const params = useParams();
  const layoutContext = useContext(LayoutContext);

  const { data } = useQuery(getDetailsGql, {
    variables: {
      slug: params.slug,
    },
  });

  const details = useMemo(() => {
    if (data?.getDetails) return data?.getDetails;
    return {};
  }, [data?.getDetails]);

  const pageTitle = details?.event?.frontendSettings?.pageTitle;
  const faviconUrl = details?.event?.frontendSettings?.assets?.favicon;

  useEffect(() => {
    layoutContext.setSlug(params.slug);
  }, [layoutContext, params.slug]);

  return (
    <>
      <Helmet>
        {pageTitle ? <title>{pageTitle}</title> : null}
        {faviconUrl ? <link rel="icon" href={faviconUrl} /> : null}
      </Helmet>
      <EventDetails details={details} />
      <SuccessSummary details={details} />
    </>
  );
}

export default CheckoutSuccessPage;
